import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logins from "../assets/images/logo.png";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../store/api/auth";
import { setCredational } from "../store/ui/loginUi";
import { SpinnerCircular } from "spinners-react";
import Modal from "react-bootstrap/Modal";
import { ToastContainer } from "react-toastify";
import http from "../services/http";
import GetStorage from "../services/Storage";
import OTPInput, { ResendOTP } from "otp-input-react";
import visable from "../assets/images/visibility.png";
import unvisable from "../assets/images/unvisibility.png";
import storage from "../services/Storage";
import { setToken } from "../store/auth/authState";
import { setUser } from "../store/auth/user";

const AnalystLogin = () => {
  const token = GetStorage.get("xAuthToken");
  const [OTP, setOTP] = useState("");
  const [showModal, setShow] = useState(false);
  const [showModals, setShows] = useState(false);
  const [showModalss, setShowss] = useState(false);
  const [uploadSpin, setUploadSpin] = useState(false);

  const handleClose = () => {
    setShow(false);
    setError("");
    setMessage("");
    setShows();
    setShowss();
  };
  const handleShow = () => setShow(true);
  const handleShows = () => setShows(true);
  const handleShowss = () => setShowss(true);

  const [message, setMessage] = useState("");
  const usera = useSelector((state) => state.login.showLoader);

  const [passwordType, setPasswordType] = useState("password");
  const [error, setError] = useState("");
  const [tokenss, setTokenss] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };
  const initialValues = {
    email: "",
    password: "",
  };
  const validationSchema = Yup.object({
    email: Yup.string().email("Invalid email format").required("required"),
    password: Yup.string()
      .required("required")
      .min(6, "Password is too short - should be 6 chars minimum."),
    // .matches(/(?=.*[0-9])/, "Password must contain a number."),
  });
  const onSubmit = async (values) => {
    dispatch(setCredational(values));
    setUploadSpin(true);
    dispatch(
      login({
        body: {
          email: values.email,
          password: values.password,
        },
        onSuccess: (res) => {
          // console.log("response login screen", res);
          setUploadSpin(false);

          const { data } = res;
          const { token, token1 } = data;
          let user = data;
           
          if(data.isMaster === true){
            dispatch(setToken(token));
            dispatch(setUser(data));
    
            storage.store("xAuthToken", token);
            storage.store("xAuth", token1);
            storage.store("user", user);
            storage.store("isApproved", res.data.data.is_approved);
    
            const strockScreen = localStorage.getItem("screen");
            if (strockScreen) {
              const routeArr = JSON.parse(strockScreen);
              if (routeArr[0] === "applicant/profile" && routeArr[1] !== "null") {
                navigate(`/applicant/profile/${routeArr[1]}`);
              }else{
                navigate("/available");
              }
            } else if (res.data.data.is_approved === 1) {
              navigate("/available");
            } else {
              navigate("/welcomePersonalInfo");
            }
          }else{
            navigate("/otpverification");
          }
        },

        onError: (error) => {
          setUploadSpin(false);


          if (error.response) {
            if (error.response.data.errors) {
              for (let key in error.response.data.errors) {
                setError(error.response.data.errors[key]);
                if(error.response.data.errors[key] === "Phone is not verified." || error.response.data.errors[key] === "Email is not verified."){
                    localStorage.setItem("signupUserDetails", JSON.stringify({ id:error.response.data.errors['analyst_id'],email:values.email, phone:error.response.data.errors['existingPhoneNumber'] }));
                    navigate('/email-phone-verification')

                } 

              }
            } else if (error.response.data.message) {
              setError(error.response.data.message);
            }
          }
        },
      })
    );
  };
  const [email, setEmail] = useState();
  const [inputText, setInputText] = useState("");

  const handleChangess = (event) => {
    setEmail(event.target.value);
  };

  const ForgetPAssword = () => {
    http
      .post(`public/analyst/password/reset-request?token=${token}`, {
        email: email,
      })
      .then((res) => {
        console.log("response in forget password", res.data);
        setMessage(res.data.message);
        if (res.data.message === true) {
          handleShows();
        } else {
          return;
        }
      })
      .catch((error) => {
        // console.log("error ", err.response.data.errors);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };

  const EnterSixDigitNumber = () => {
    http
      .post(`public/analyst/password/reset-code?token=${token}`, {
        code: OTP,
      })
      .then((res) => {
        console.log("response in forget===>", res.data.token);
        setTokenss(res.data.token);
        if (res.data.message === true) {
          handleShowss();
        } else {
          return;
        }
      })
      .catch((error) => {
        // console.log("error ", err.response.data.errors);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };
  const EnterPassword = () => {
    http
      .put(`api/analyst/reset-password?token=${tokenss.token}`, {
        password: inputText,
      })
      .then((res) => {
        console.log("response in ===>", res.data);
        handleClose();
      })
      .catch((error) => {
        // console.log("error ", error.response.data.errors);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
              console.log("error---->", error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
            console.log("error1---->", error.response.data.message);
          }
        }
      });
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ values, handleChange, handleBlur, handleSubmit }) => (
          <section className="login_wraper">
            <div className="login_inner">
              <div className="login_logo mb_40">
                {" "}
                <img src={logins} alt="" />{" "}
              </div>
              <h1 className="mb_30 main_title">Analyst Login</h1>
              <p className="mb_40 them_para">
                Please enter valid email Id and a strong password to procced
                with the login process.
              </p>
              <form>
                <div className="form-group icon">
                  <input
                    type="email"
                    name="email"
                    onChange={handleChange("email")}
                    onBlur={handleBlur("email")}
                    value={values.email}
                    className="custom_input form-control"
                    placeholder="Email ID"
                  />
                  <div
                    style={{
                      color: "red",
                    }}
                  >
                    <ErrorMessage name="email" />
                  </div>
                </div>
                <div class="form-group icon">
                  <input
                    name="password"
                    onChange={handleChange("password")}
                    onBlur={handleBlur("password")}
                    value={values.password}
                    type={passwordType}
                    className="custom_input form-control"
                    placeholder="password"
                  />
                  <div class="img_icon">
                    {passwordType === "password" ? (
                      <a>
                        <img src={visable} alt="" onClick={togglePassword} />
                      </a>
                    ) : (
                      <a>
                        <img src={unvisable} alt="" onClick={togglePassword} />{" "}
                      </a>
                    )}
                  </div>
                </div>
                <div
                  style={{
                    color: "red",
                  }}
                >
                  <ErrorMessage name="password" />
                </div>
                <h5 style={{ color: "red" }}>{error}</h5>
                <div className="btn_wraper">
                  <button
                    type="submit"
                    className="them_btn mt_40 mb_30"
                    onClick={handleSubmit}
                  >
                    {uploadSpin ? (
                      <SpinnerCircular className="button-spin" />
                    ) : (
                      "Login"
                    )}
                  </button>
                </div>{" "}
              </form>
              <p
                className="btn-link"
                onClick={() => navigate("/signUpScreen")}
                style={{
                  cursor: "pointer",
                }}
              >
                Register
              </p>{" "}
              <Link to="/forgetPassword">
                <p
                  className="btn-link  d-block"
                  // onClick={handleShow}
                  style={{ cursor: "pointer" }}
                >
                  Forgot Password?
                </p>{" "}
              </Link>
            </div>
          </section>
        )}
      </Formik>
      <Modal show={showModal} onHide={handleClose}>
        <Modal.Body>
          <>
            <div class=" " role="document">
              <div class="modal-content">
                <div class="modal-header pb-0">
                  <h1 class=" main_title text-center d-flex">Analyst Forgot</h1>
                  <button
                    onClick={handleClose}
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    {" "}
                    <span aria-hidden="true">&times;</span>{" "}
                  </button>
                </div>
                <div class="modal-body">
                  <form
                    action="index_submit"
                    method="get"
                    accept-charset="utf-8"
                  >
                    <div class="form-group">
                      <label>Enter your Email</label>
                      <input
                        type="text"
                        name=""
                        class="form-control"
                        onChange={handleChangess}
                        value={email}
                        placeholder="Email"
                      />{" "}
                    </div>
                    <h5 style={{ color: "green" }}>{message}</h5>
                    <h5 style={{ color: "red" }}>{error}</h5>
                    <div class="btn_wraper d-flex justify-content-center ">
                      <button
                        type="button"
                        class="them_btn"
                        onClick={ForgetPAssword}
                      >
                        Forgot
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </>
        </Modal.Body>
        <ToastContainer />
      </Modal>

      <Modal show={showModals} onHide={handleClose}>
        <Modal.Body>
          <>
            <div class=" " role="document">
              <div class="modal-content">
                <div class="modal-header pb-0">
                  <h1 class=" main_title text-center d-flex">Analyst Forgot</h1>
                  <button
                    onClick={handleClose}
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    {" "}
                    <span aria-hidden="true">&times;</span>{" "}
                  </button>
                </div>
                <div class="modal-body">
                  <form
                    action="index_submit"
                    method="get"
                    accept-charset="utf-8"
                  >
                    <div class="form-group">
                      <label>Enter 6 digit code </label>
                      <OTPInput
                        value={OTP}
                        onChange={setOTP}
                        autoFocus
                        OTPLength={6}
                        otpType="number"
                      />
                      <label></label>
                    </div>
                    <h5 style={{ color: "green" }}>{message}</h5>
                    <h5 style={{ color: "red" }}>{error}</h5>
                    <div class="btn_wraper d-flex justify-content-center ">
                      <button
                        type="button"
                        class="them_btn"
                        onClick={EnterSixDigitNumber}
                      >
                        Enter
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </>
        </Modal.Body>
      </Modal>

      <Modal show={showModalss} onHide={handleClose}>
        <Modal.Body>
          <>
            <div class=" " role="document">
              <div class="modal-content">
                <div class="modal-header pb-0">
                  <h1 class=" main_title text-center d-flex">Analyst Forgot</h1>
                  <button
                    onClick={handleClose}
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    {" "}
                    <span aria-hidden="true">&times;</span>{" "}
                  </button>
                </div>
                <div class="modal-body">
                  <form
                    action="index_submit"
                    method="get"
                    accept-charset="utf-8"
                  >
                    <div class="form-group">
                      <label>Enter your new password </label>
                      <input
                        type="password"
                        name="password"
                        onChange={(e) => {
                          setInputText(e.target.value);
                        }}
                        className="custom_input form-control"
                        placeholder="Password"
                      />
                      <label></label>
                    </div>
                    <h5 style={{ color: "green" }}>{message}</h5>
                    <h5 style={{ color: "red" }}>{error}</h5>
                    <div class="btn_wraper d-flex justify-content-center ">
                      <button
                        type="button"
                        class="them_btn"
                        onClick={EnterPassword}
                      >
                        Enter
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default AnalystLogin;
